export const businessTypeOptions = [
  {
    label: "Company",
    value: "company",
  },
  {
    label: "Limited Liability Partnership",
    value: "limited_liability_partnership",
    disable: true,
  },
  {
    label: "Partnership",
    value: "partnership",
    disable: true,
  },
  {
    label: "Sole Proprietor",
    value: "sole_proprietor",
    disable: true,
  },
  {
    label: "Individual",
    value: "individual",
    disable: true,
  },
];

export const businessDocumentsOptions = [
  {
    label: "GSTIN",
    value: "GSTIN",
  },

  {
    label: "Business PAN",
    value: "Business_PAN",
  },
  {
    label: "CIN",
    value: "CIN",
  },
];

export const dbaTooltip = `Doing Business As, this is a 16 character customer-facing business name. Special characters like <, >, ', or " are not allowed. This is what will appear in your customer's statement descriptor if Xflow moves funds from them on your behalf.`;

export const companyPositionOptions: {
  label: string;
  value: "director" | "owner" | "representative";
}[] = [
  {
    label: "Director",
    value: "director",
  },
  {
    label: "Owner",
    value: "owner",
  },
  {
    label: "Representative",
    value: "representative",
  },
];

export const currencyOptions = [
  {
    label: "USD",
    value: "USD",
  },
  {
    label: "INR",
    value: "INR",
  },
];

export const xflowCountryOptions = [
  {
    label: "USA",
    value: "US",
  },
  // {
  //   label: "India",
  //   value: "IN",
  // },
];

export const xFlowInvoiceTransactionTypes = [
  {
    label: "Goods",
    value: "goods",
  },
  {
    label: "Services",
    value: "services",
  },
  {
    label: "Software",
    value: "software",
  },
];

// export const PURPOSE_CODES = [
//   // Goods (Export of Goods)
//   {
//     value: "P0102",
//     label:
//       "P0102 - Realisation of export bills (in respect of goods) sent on collection (full invoice value)",
//   },
//   {
//     value: "P0103",
//     label:
//       "P0103 - Advance receipts against export contracts, which will be covered later by GR/PP/SOFTEX/SDF",
//   },
//   {
//     value: "P0104",
//     label:
//       "P0104 - Receipts against export of goods not covered by the GR/PP/SOFTEX/EC copy of shipping bill etc.",
//   },
//   {
//     value: "P0105",
//     label: "P0105 - Export bills (in respect of goods) sent on collection.",
//   },
//   {
//     value: "P0807",
//     label: "P0807 - Off site Software Exports",
//   },

//   // Services
//   {
//     value: "P0801",
//     label: "P0801 - Hardware consultancy/implementation",
//   },
//   {
//     value: "P0803",
//     label: "P0803 - Data base, data processing charges",
//   },
//   {
//     value: "P0808",
//     label:
//       "P0808 - Telecommunication services including electronic mail services and voice mail services",
//   },
//   {
//     value: "P0902",
//     label:
//       "P0902 - Receipts for use, through licensing arrangements, of produced originals or prototypes (such as manuscripts and films)",
//   },
//   {
//     value: "P1003",
//     label:
//       "P1003 - Operational leasing services (other than financial leasing and without operating crew) including charter hire",
//   },
//   {
//     value: "P1004",
//     label: "P1004 - Legal services",
//   },
//   {
//     value: "P1005",
//     label:
//       "P1005 - Accounting, auditing, book keeping and tax consulting services",
//   },
//   {
//     value: "P1006",
//     label:
//       "P1006 - Business and management consultancy and public relations services",
//   },
//   {
//     value: "P1008",
//     label: "P1008 - Research and Development services",
//   },
//   {
//     value: "P1014",
//     label: "P1014 - Engineering Services",
//   },
//   {
//     value: "P1016",
//     label: "P1016 - Market research and public opinion polling service",
//   },
//   {
//     value: "P1022",
//     label:
//       "P1022 - Other Technical Services including scientific/space services",
//   },
//   {
//     value: "P0802",
//     label:
//       "P0802 - Software consultancy/implementation (other than those covered in SOFTEX form)",
//   },

//   // Software
//   {
//     value: "P0804",
//     label: "P0804 - Repair and maintenance of computer and software",
//   },
//   {
//     value: "P0806",
//     label:
//       "P0806 - Other information services- Subscription to newspapers, periodicals, etc.",
//   },
//   // P0807 is already included above; remove duplication if needed
// ];

export const PURPOSE_CODES = [
  // Goods (Export of Goods)
  {
    value: "P0102",
    label: "P0102 - Export bill realisation (collection)",
  },
  {
    value: "P0103",
    label: "P0103 - Advance receipts for export contracts",
  },
  {
    value: "P0104",
    label: "P0104 - Receipts for goods (no GR/PP/SOFTEX)",
  },
  {
    value: "P0105",
    label: "P0105 - Export bills sent on collection",
  },
  {
    value: "P0807",
    label: "P0807 - Offsite software exports",
  },

  // Services
  {
    value: "P0801",
    label: "P0801 - Hardware consulting/implementation",
  },
  {
    value: "P0803",
    label: "P0803 - Database & data processing",
  },
  {
    value: "P0808",
    label: "P0808 - Telecommunication services",
  },
  {
    value: "P0902",
    label: "P0902 - Licensing of original works",
  },
  {
    value: "P1003",
    label: "P1003 - Operational leasing/charter hire",
  },
  {
    value: "P1004",
    label: "P1004 - Legal services",
  },
  {
    value: "P1005",
    label: "P1005 - Accounting & tax services",
  },
  {
    value: "P1006",
    label: "P1006 - Business & PR consulting",
  },
  {
    value: "P1008",
    label: "P1008 - R&D services",
  },
  {
    value: "P1014",
    label: "P1014 - Engineering services",
  },
  {
    value: "P1016",
    label: "P1016 - Market research & polling",
  },
  {
    value: "P1022",
    label: "P1022 - Technical & space services",
  },
  {
    value: "P0802",
    label: "P0802 - Software consulting (non-SOFTEX)",
  },

  // Software
  {
    value: "P0804",
    label: "P0804 - Computer/software repair",
  },
  {
    value: "P0806",
    label: "P0806 - Info services (news, subscriptions)",
  },
];
